<template>
    <div class="container" :style='{marginRight:right*1+"px",paddingBottom:paddButtom+"px"}'>
         <div class="common-items-center">
            <div v-if="!!title" class="title">{{title}}</div>
            <div class="common-relatives" :style='{width:width*1+"px",marginLeft:left*1+"px"}'>
               <el-input :placeholder="placeholder" :size="size" :type="type"  @input="getValue" :maxlength="maxlength*1" v-model="val"/>
            </div>
         </div>
    </div>
  </template> 
  <script>
  export default {
    name: 'Login',
    data:()=>({
       val:""
    }),
    props: {
      title: {
         type: String,
         default: "",
      },
      size:{
         type: String,
         default: null,
      },
      placeholder: {
         type: String,
         default: "请输入",
      },
      left:{
         type: String,
         default: "0",
      },
      right:{
         type: String,
         default: "15",
      },
      width: {
         type: String,
         default: "250",
      },

      maxlength:{
         type: String,
         default: "20",
      },
      type:{
         type: String,
         default: "text",
      },
      paddButtom:{
         type: String,
         default: "0",
      },
      
      keyVal:{
         type: String,
         default: "key",
      }
   },
   methods:{
      //获取值
      getValue(){
        let parms={
           key:this.keyVal,
           val:this.val
        }
        this.$emit('getVal',parms)
      },
      //设置默值
      setVal(e){
         this.val = e 
      }
   }
  }
  </script>
  <style lang="scss" scoped>
      .title{
         font-size: 14px;
         color: #606266;
         font-weight: 600;
         text-align: right;
         margin-right: 8px;
      }
      .inputBlock{
         width: 180px;
      }
  </style>
  